/**
 * Sales pipeline gate.
 *
 * The Sales tab is Exitium's own tool for selling Exitium to furniture
 * stores. It is NOT a store feature. It renders only when BOTH hold:
 *   1. the store open in the dashboard is on the allowlist below
 *      (per-STORE, like phoneAgentAccess.js), and
 *   2. the signed-in email is on the allowlist below
 *      (per-USER, like MARKETING_OWNER_EMAILS in useReceiptDashboard.jsx).
 *
 * Live customer stores never match 1, so the tab never mounts for them,
 * not even off a stale ?view=sales deep link. A code commit is the only
 * way to widen access: nothing in dashboardTabRestrictions (JSON or plan
 * config) can turn it on.
 */

const SALES_PIPELINE_STORE_IDS = new Set([
  '1e31fec9-882d-44b4-b870-1899f759764b', // Testing Store
]);

const SALES_PIPELINE_EMAILS = [
  'byars.jp5@gmail.com', // Testing Store login: Phillip and the sales reps
];

/**
 * @param {string | null | undefined} storeId
 * @param {string | null | undefined} email
 * @returns {boolean}
 */
// Reps share the login and pick who they are. Only these rep names run
// the list itself (import, bulk assign); the reps work what is in front
// of them.
const SALES_ADMIN_REP_NAMES = ['phillip'];
export function isSalesAdminRep(rep) {
  if (!rep) return true; // nobody picked yet: the owner setting things up
  return SALES_ADMIN_REP_NAMES.includes(String(rep.name || '').trim().toLowerCase().split(/\s+/)[0]);
}

export function isSalesPipelineEnabled(storeId, email) {
  if (!storeId || !SALES_PIPELINE_STORE_IDS.has(storeId)) return false;
  const e = String(email || '').trim().toLowerCase();
  return !!e && SALES_PIPELINE_EMAILS.includes(e);
}
